import { Component, Input } from '@angular/core';

@Component({
  selector: 'c-item-notification',
  standalone: false,
  templateUrl: './item-notification.component.html',
  styleUrl: './item-notification.component.css',
})
export class ItemNotificationComponent {
  @Input() titulo!: string;
  @Input() cuerpo!: string;
  @Input() fecha!: Date;
  @Input() abierto!: boolean;
}
